<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
      <navbar :title="$t('vehicle.vehicle')" class="mb-1"/>
      <vehicle-search v-if="!editMode" class="my-2" @search="fetchVehicles"/>
      <div v-if="!editMode" class="ml-3 mr-3 data-list-item add" @click.stop="addVehicle">
          <div class="item-img-cont add-title">
            <i class="fa fa-plus" />
          </div>
          <div class="item-text-cont">
            <span class="item-title-add">{{ $t('common.add_new') }}</span>
            <font-awesome-icon icon="file-contract" class="card-body-icon"/>
          </div>
      </div>
    <Transition name="fade">
      <div>
        <vehicle-tabbed
          v-if="editMode && vehicle"
          :vehicle="vehicle"
          :edit-mode="vehicle.id > 0"
          :user="user"
          @close="showList"
          @close-and-update="closeAndUpdate"
        />

        <vehicle-list
          v-if="!editMode"
          :results="results"
          @edit="editVehicle"
        />
      </div>
    </Transition>

    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>



<script>
import {vehicleHelper} from '../mixins/VehicleMixin'
import {restApi} from '../mixins/RestApiMixin'
import VehicleSearch from "@/components/vehicle/tabbed/VehicleSearch.vue";
import VehicleList from './VehicleList'
import VehicleTabbed from "@/components/vehicle/tabbed/VehicleTabbed.vue";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'Vehicles',
    components: {Navbar, VehicleTabbed, VehicleList, VehicleSearch},
    mixins: [vehicleHelper, restApi],
    props: {
        result: Object,
        user: Object
    },
    data: function () {
        return {
            selected: [],
            results: [],
            lastSearchParams: [],
            vehicle: null,
            editMode: false,
            loading: false,

        }
    },
    methods: {
        fetchVehicles: function (params) {
            this.lastSearchParams = params
            this.loading = true
            this.results = []
            this.restFetchParams(this.vehicleUrl, params, this.handleResponse)
        },

        handleResponse: function (response) {
            this.results = response.data
            this.loading = false
        },

        editVehicle: function (vehicle) {
            this.vehicle = vehicle
            this.editMode = true
        },

        addVehicle: function () {
            this.vehicle = this.newVehicle()
            this.editMode = true
        },

        showList: function () {
            this.vehicle = null
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.fetchVehicles(this.lastSearchParams)
            this.showList()
        }
    }
}
</script>
